import config from 'message-control/config'

const newJavaApi = `${config.apiHost}/oem-crm_new_java`

export default {
    // sensitive-behavior-record页面
    records: {
        url: `${newJavaApi}/api/risk-management/sensitive-behavior/search`,
        type: 'GET',
    },
    // 处理敏感词
    updateRecord: {
        url: `${newJavaApi}/api/risk-management/sensitive-behavior`,
        type: 'POST',
    },
    // 敏感行为列表
    types: {
        url: `${newJavaApi}/api/risk-management/sensitive-behavior/type`,
        type: 'GET',
    },
    // 导出报表
    exportRecords: {
        url: `${newJavaApi}/api/risk-management/sensitive-behavior/export`,
        type: 'GET',
    },

    // 敏感行为管理
    behaviors: {
        url: `${newJavaApi}/api/risk-management/sensitive-behavior/manager`,
        type: 'GET',
    },
    updateBehaviorStatus: {
        url: `${newJavaApi}/api/risk-management/sensitive-behavior/manager`,
        type: 'POST',
    },
}
